import React from "react";
import "./index.css";

const TextWithTitleChild = ({ articles }) => {
  return (
    <div className="with-title-child">
      {articles.map((article, index) => {
        return (
          <article
            className="with-title-child__article"
            key={article.title + index}
          >
            <h3 className="with-title-child__title">{article.title}</h3>
            {article.text.map((p, index) => (
              <p className="with-title-child__text" key={p + index}>
                {p}
              </p>
            ))}
          </article>
        );
      })}
    </div>
  );
};

export default TextWithTitleChild;
